import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Avatar,
  Theme,
} from "@material-ui/core";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import RemoveShoppingCartIcon from "@material-ui/icons/RemoveShoppingCart";
import {
  useStats,
  useThisMonthOrderStat,
  useLastMonthOrderStat,
} from "store/stats/selectors";
import { calculateChange } from "utils/utils";
import { WithLoading } from "components";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "100%",
  },
  content: {
    alignItems: "center",
    display: "flex",
  },
  title: {
    fontWeight: 700,
  },
  avatar: {
    backgroundColor: theme.palette.error.main,
    height: 56,
    width: 56,
  },
  icon: {
    height: 32,
    width: 32,
  },
  difference: {
    marginTop: theme.spacing(2),
    display: "flex",
    alignItems: "center",
  },
  differenceValue: {
    marginRight: theme.spacing(1),
  },
  improvedColor: {
    color: theme.palette.success.dark,
  },
  worsenColor: {
    color: theme.palette.error.dark,
  },
}));

const Budget = () => {
  const classes = useStyles();

  const stats = useStats();

  const thisMonth = useThisMonthOrderStat();
  const lastMonth = useLastMonthOrderStat();

  const { isPostive, absDiffPercent } = calculateChange(
    lastMonth.cancelled,
    thisMonth.cancelled
  );

  return (
    <Card className={classes.root}>
      <WithLoading loading={stats.monthlyOrderStatsLoading}>
        <CardContent>
          <Grid container justify="space-between">
            <Grid item>
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
                variant="body2"
              >
                CANCELLED ORDERS
              </Typography>
              <Typography variant="h3">{thisMonth.cancelled}</Typography>
            </Grid>
            <Grid item>
              <Avatar className={classes.avatar}>
                <RemoveShoppingCartIcon className={classes.icon} />
              </Avatar>
            </Grid>
          </Grid>
          <div className={classes.difference}>
            {isPostive ? (
              <ArrowUpwardIcon className={classes.worsenColor} />
            ) : (
              <ArrowDownwardIcon className={classes.improvedColor} />
            )}
            <Typography
              className={clsx(
                {
                  [classes.improvedColor]: !isPostive,
                  [classes.worsenColor]: isPostive,
                },
                classes.differenceValue
              )}
              variant="body2"
            >
              {absDiffPercent}%
            </Typography>
            <Typography variant="caption">Since last month</Typography>
          </div>
        </CardContent>
      </WithLoading>
    </Card>
  );
};

Budget.propTypes = {
  className: PropTypes.string,
};

export default Budget;
